export const API = process.env.REACT_APP_API_URL;

export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL;

export const PUBLIC_URL = process.env.PUBLIC_URL;

export const REACT_APP_AUTH_URL = process.env.REACT_APP_AUTH_URL;